import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const requireModule = require.context("./store_modules", true, /index.js/);
const modules = {};
requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\/index\.js)/g, "");
  modules[moduleName] = requireModule(fileName).default;
});

export default new Vuex.Store({
  modules
});
